import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";
import { Button } from "../../utils/Button";
import { BootScene } from "../BootScene";
import { BoardContainer } from "../board-scene/BoardContainer";
import { TutorialScene } from "./TutorialScene";

export class TutorialMessagesLayer extends Phaser.GameObjects.Container {

    private centralMessageContainer: Phaser.GameObjects.Container;
    private upperMessageContainer: Phaser.GameObjects.Container;
    private upperText: Phaser.GameObjects.Text;
    private centralTitleText: Phaser.GameObjects.Text;
    private centralText: Phaser.GameObjects.Text;

    constructor(scene: Phaser.Scene) {

        super(scene);

        const gameText = this.scene.game.cache.json.get("game-text");

        this.upperMessageContainer = new Phaser.GameObjects.Container(this.scene);
        this.upperMessageContainer.x = GameConstants.GAME_WIDTH / 2;
        this.upperMessageContainer.y = 80;
        this.upperMessageContainer.scaleY = GameVars.scaleY;
        this.add(this.upperMessageContainer);

        const upperBackground = new Phaser.GameObjects.Graphics(this.scene);
        upperBackground.fillStyle(0x132A4B, .85);
        upperBackground.fillRect(-GameConstants.GAME_WIDTH / 2, 0, GameConstants.GAME_WIDTH, 70);
        this.upperMessageContainer.add(upperBackground);

        this.upperText = new Phaser.GameObjects.Text(this.scene, 0, 32 + (BootScene.textYgap * -65), gameText.TUTORIAL_MESSAGE_1, { fontFamily: "Montserrat-Black", fontSize: "30px", color: "#FFFFFF" });
        this.upperText.setOrigin(.5,BootScene.originY);
        this.upperMessageContainer.add(this.upperText);

        this.upperMessageContainer.visible = false;

        this.centralMessageContainer = new Phaser.GameObjects.Container(this.scene);
        this.centralMessageContainer.x = GameConstants.GAME_WIDTH / 2;
        this.centralMessageContainer.y = GameConstants.GAME_HEIGHT / 2;
        this.centralMessageContainer.scaleX = BoardContainer.currentInstance.scaleX * .8;
        this.centralMessageContainer.scaleY = BoardContainer.currentInstance.scaleY * .8;
        this.add(this.centralMessageContainer);

        const centralBackground = new Phaser.GameObjects.Graphics(this.scene);
        centralBackground.fillStyle(0x132A4B, .85);
        centralBackground.fillRoundedRect(-610 / 2, -610 / 2, 610, 610, 40);
        this.centralMessageContainer.add(centralBackground);

        this.centralTitleText = new Phaser.GameObjects.Text(this.scene, 0, -220 + (BootScene.textYgap * 1), gameText.TUTORIAL_MESSAGE_2, { fontFamily: "Teko-Medium", fontSize: "80px", color: "#FFFFFF" });
        this.centralTitleText.setOrigin(.5,BootScene.originY);
        this.centralTitleText.setShadow(0, 4, "#132A4B", 0, false, true);
        this.centralMessageContainer.add(this.centralTitleText);

        this.centralText = new Phaser.GameObjects.Text(this.scene, 0, -20 + (BootScene.textYgap * -40), gameText.TUTORIAL_MESSAGE_3, { fontFamily: "Montserrat-Black", fontSize: "30px", color: "#FFFFFF", align: "center" });
        this.centralText.setOrigin(.5,BootScene.originY);
        this.centralText.setLineSpacing(20 + (BootScene.textYgap * -360));
        this.centralMessageContainer.add(this.centralText);

        const nextButton = new Button(this.scene, 0, 205, "texture_atlas_1", "btn_back_off", "btn_back_on");
        nextButton.scaleX = -1;
        nextButton.onDown(this.onClickNext, this);
        this.centralMessageContainer.add(nextButton);

        this.scene.tweens.add({
            targets: this.centralMessageContainer,
            scaleX: BoardContainer.currentInstance.scaleX,
            scaleY: BoardContainer.currentInstance.scaleY,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 200
        });
    }

    public onTutorialStage1(): void {

        this.centralMessageContainer.visible = false;
        this.upperMessageContainer.visible = true;
    }

    public onTutorialStage3(): void {

        const gameText = this.scene.game.cache.json.get("game-text");

        this.upperText.text = gameText.TUTORIAL_MESSAGE_4;
    }

    public onShot(): void {

        this.upperMessageContainer.visible = false;
    }

    public onTutorialTurnCompleted(): void {

        this.centralMessageContainer.scaleX = BoardContainer.currentInstance.scaleX * .85;
        this.centralMessageContainer.scaleY = BoardContainer.currentInstance.scaleY * .85;

        this.scene.tweens.add({
            targets: this.centralMessageContainer,
            scaleX: BoardContainer.currentInstance.scaleX,
            scaleY: BoardContainer.currentInstance.scaleY,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 200
        });

        const gameText = this.scene.game.cache.json.get("game-text");

        this.centralMessageContainer.visible = true;

        this.centralTitleText.text = gameText.TUTORIAL_MESSAGE_5;
        this.centralText.text = gameText.TUTORIAL_MESSAGE_6;
    }

    private onClickNext(): void {

        TutorialScene.currentInstance.tutorialManager.onNext();
    }
}
